<template>
  <div class="container-configurations">
    <div class="config-col">
      <v-card
        v-for="c in leftCards"
        :key="c.cardId"
        class="container-card"
      >
        <div class="container-header">
          <div class="container-title-card">
            <div class="d-flex align-center ga-2">
              <strong>{{ getProcessById(c.item.fields.processes)?.nome || 'Processo desconhecido' }}</strong>

              <rb-switch
                v-model="c.item.fields.status"
                :label="c.item.fields.status ? 'Ativado' : 'Desativado'"
                @change="toggleSwitchStatus(c.item)"
              />
            </div>

            <div class="d-flex ga-2">
              <v-btn icon size="small" variant="text" @click="openDisablePopup(c.item)">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M6.97705 21.2871C6.42705 21.2871 5.95622 21.0913 5.56455 20.6996C5.17288 20.3079 4.97705 19.8371 4.97705 19.2871V6.28711H3.97705V4.28711H8.97705V3.28711H14.9771V4.28711H19.9771V6.28711H18.9771V19.2871C18.9771 19.8371 18.7812 20.3079 18.3896 20.6996C17.9979 21.0913 17.5271 21.2871 16.9771 21.2871H6.97705ZM8.97705 17.2871H10.9771V8.28711H8.97705V17.2871ZM12.9771 17.2871H14.9771V8.28711H12.9771V17.2871Z"
                    fill="#505353"
                  />
                </svg>
              </v-btn>

              <v-btn icon size="small" variant="text" @click="toggleDropdown(c.cardId)">
                <v-icon>
                  {{ openCard === c.cardId ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                </v-icon>
              </v-btn>
            </div>
          </div>

          <div class="steps-wrap">
            <ChevronSteps
              :total="getTotalSteps(c.item)"
              :filled-indexes="getFilledIndexes(c.item)"
            />
          </div>
        </div>

        <v-expand-transition>
          <div v-show="openCard === c.cardId">
            <v-divider/>

            <div class="container-data-form pa-4">
              <h4 class="mb-2 title-form">Período da campanha</h4>
              <p class="desc-form mb-6">Todos os registros criados ou alterados dentro do período receberão atualizações.</p>
              <v-date-input
                v-model="c.item.fields.startDate"
                label="A partir do dia"
                density="comfortable"
                prepend-icon=""
                append-inner-icon="mdi-calendar"
                @blur="dateTouched = true"
              />
            </div>

            <v-divider/>

            <div class="mt-4 container-data-form pa-4">
              <h4 class="mb-2 title-form">Etapas</h4>
              <p class="desc-form mb-6">Registros nessas etapas não necessitam de análise, recebendo probabilidades fixas.</p>

              <v-autocomplete
                class="input-form"
                v-model="c.item.fields.stages"
                :items="getEtapas(c.item)"
                item-title="titulo"
                item-value="id"
                label="Escolha as etapas de conversão"
                multiple
                chips
                closable-chips
                density="comfortable"
              >
                <template v-slot:item="{ props, item }">
                  <v-list-item
                    v-bind="props"
                    :active="false"
                    :title="item.raw.titulo"
                  >
                    <template v-slot:prepend="{ isSelected }">
                      <v-checkbox-btn :model-value="isSelected"></v-checkbox-btn>
                    </template>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </div>

            <v-divider />

            <div class="mt-4 container-data-form pa-4">
              <h4 class="mb-2 title-form">Público-alvo</h4>
              <p class="desc-form mb-6">Defina o público-alvo para o qual as predições serão geradas.</p>

              <v-autocomplete
                class="input-form"
                v-model="c.item.fields.level"
                :items="edulevels"
                item-title="titulo"
                item-value="id"
                label="Nível de ensino"
                multiple
                chips
                closable-chips
                density="comfortable"
                :menu-props="{ closeOnContentClick: false, closeOnBack: false }"
                :hide-no-data="true"
                :no-filter="false"
              >
                <template #prepend-item>
                  <v-list-item @click.stop :active="false">
                    <v-checkbox
                      label="Selecionar todos"
                      density="compact"
                      hide-details
                      :indeterminate="isSomeSelected(c.item, 'level', edulevels)"
                      :model-value="isAllSelected(c.item, 'level', edulevels)"
                      @mousedown.prevent
                      @click.stop
                      @update:model-value="(v) => onToggleAll(c.item, 'level', edulevels, v)"
                    />
                  </v-list-item>
                  <v-divider class="mt-1" />
                </template>

                <template #item="{ props, item: opt }">
                  <v-list-item v-bind="props" :active="false" :title="opt.raw.titulo" @click.stop>
                    <template #prepend>
                      <v-checkbox
                        density="compact"
                        hide-details
                        :model-value="(c.item.fields.level || []).map(String).includes(String(opt.raw.id))"
                        @mousedown.prevent
                        @click.stop
                        @update:model-value="(v) => onToggleSingle(c.item, 'level', edulevels, opt.raw.id, v)"
                      />
                    </template>
                  </v-list-item>
                </template>
              </v-autocomplete>

              <v-autocomplete
                class="input-form"
                v-model="c.item.fields.modality"
                :items="modalities"
                item-title="titulo"
                item-value="id"
                label="Modalidade"
                multiple
                chips
                closable-chips
                density="comfortable"
                :menu-props="{ closeOnContentClick: false, closeOnBack: false }"
                :hide-no-data="true"
                :no-filter="false"
              >
                <template #prepend-item>
                  <v-list-item @click.stop :active="false">
                    <v-checkbox
                      label="Selecionar todos"
                      density="compact"
                      hide-details
                      :indeterminate="isSomeSelected(c.item, 'modality', modalities)"
                      :model-value="isAllSelected(c.item, 'modality', modalities)"
                      @mousedown.prevent
                      @click.stop
                      @update:model-value="(v) => onToggleAll(c.item, 'modality', modalities, v)"
                    />
                  </v-list-item>
                  <v-divider class="mt-1" />
                </template>

                <template #item="{ props, item: opt }">
                  <v-list-item v-bind="props" :active="false" :title="opt.raw.titulo" @click.stop>
                    <template #prepend>
                      <v-checkbox
                        density="compact"
                        hide-details
                        :model-value="(c.item.fields.modality || []).map(String).includes(String(opt.raw.id))"
                        @mousedown.prevent
                        @click.stop
                        @update:model-value="(v) => onToggleSingle(c.item, 'modality', modalities, opt.raw.id, v)"
                      />
                    </template>
                  </v-list-item>
                </template>
              </v-autocomplete>

              <v-autocomplete
                class="input-form"
                v-model="c.item.fields.locations"
                :items="offers"
                item-title="titulo"
                item-value="id"
                label="Locais"
                multiple
                chips
                closable-chips
                density="comfortable"
                :menu-props="{ closeOnContentClick: false, closeOnBack: false }"
                :hide-no-data="true"
                :no-filter="false"
              >
                <template #prepend-item>
                  <v-list-item @click.stop :active="false">
                    <v-checkbox
                      label="Selecionar todos"
                      density="compact"
                      hide-details
                      :indeterminate="isSomeSelected(c.item, 'locations', offers)"
                      :model-value="isAllSelected(c.item, 'locations', offers)"
                      @mousedown.prevent
                      @click.stop
                      @update:model-value="(v) => onToggleAll(c.item, 'locations', offers, v)"
                    />
                  </v-list-item>
                  <v-divider class="mt-1" />
                </template>

                <template #item="{ props, item: opt }">
                  <v-list-item v-bind="props" :active="false" :title="opt.raw.titulo" @click.stop>
                    <template #prepend>
                      <v-checkbox
                        density="compact"
                        hide-details
                        :model-value="(c.item.fields.locations || []).map(String).includes(String(opt.raw.id))"
                        @mousedown.prevent
                        @click.stop
                        @update:model-value="(v) => onToggleSingle(c.item, 'locations', offers, opt.raw.id, v)"
                      />
                    </template>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </div>
            <v-divider />
            <v-card-actions class="d-flex justify-end px-8 py-4">
              <v-btn
                class="px-6 py-5 d-flex"
                rounded="xl"
                variant="outlined"
                :style="{ color: '#505353', borderColor: '#C5C7C6' }"
                @click="onCancel"
                :disabled="isSubmitting"
              >
                Cancelar
              </v-btn>

              <v-btn
                variant="elevated"
                color="primary-60"
                class="px-6 py-5 d-flex elevation-0"
                rounded="xl"
                @click="onConfirmClose(c.item)"
                :disabled="isSubmitting || isFormInvalid || !hasChanges(c.item)"
              >
                Salvar
              </v-btn>
            </v-card-actions>
          </div>
        </v-expand-transition>
      </v-card>
    </div>

    <div class="config-col">
      <v-card
        v-for="c in rightCards"
        :key="c.cardId"
        class="container-card"
      >
        <div class="container-header">
          <div class="container-title-card">
            <div class="d-flex align-center ga-2">
              <strong>{{ getProcessById(c.item.fields.processes)?.nome || 'Processo desconhecido' }}</strong>

              <rb-switch
                v-model="c.item.fields.status"
                :label="c.item.fields.status ? 'Ativado' : 'Desativado'"
                @change="toggleSwitchStatus(c.item)"
              />
            </div>

            <div class="d-flex ga-2">
              <v-btn icon size="small" variant="text" @click="openDisablePopup(c.item)">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M6.97705 21.2871C6.42705 21.2871 5.95622 21.0913 5.56455 20.6996C5.17288 20.3079 4.97705 19.8371 4.97705 19.2871V6.28711H3.97705V4.28711H8.97705V3.28711H14.9771V4.28711H19.9771V6.28711H18.9771V19.2871C18.9771 19.8371 18.7812 20.3079 18.3896 20.6996C17.9979 21.0913 17.5271 21.2871 16.9771 21.2871H6.97705ZM8.97705 17.2871H10.9771V8.28711H8.97705V17.2871ZM12.9771 17.2871H14.9771V8.28711H12.9771V17.2871Z"
                    fill="#505353"
                  />
                </svg>
              </v-btn>

              <v-btn icon size="small" variant="text" @click="toggleDropdown(c.cardId)">
                <v-icon>
                  {{ openCard === c.cardId ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                </v-icon>
              </v-btn>
            </div>
          </div>

          <div class="steps-wrap">
            <ChevronSteps
              :total="getTotalSteps(c.item)"
              :filled-indexes="getFilledIndexes(c.item)"
            />
          </div>
        </div>

        <v-expand-transition>
          <div v-show="openCard === c.cardId">
            <v-divider/>

            <div class="container-data-form pa-4">
              <h4 class="mb-2 title-form">Período da campanha</h4>
              <p class="desc-form mb-6">Todos os registros criados ou alterados dentro do período receberão atualizações.</p>
              <v-date-input
                v-model="c.item.fields.startDate"
                label="A partir do dia"
                density="comfortable"
                prepend-icon=""
                append-inner-icon="mdi-calendar"
                @blur="dateTouched = true"
              />
            </div>

            <v-divider/>

            <div class="mt-4 container-data-form pa-4">
              <h4 class="mb-2 title-form">Etapas</h4>
              <p class="desc-form mb-6">Registros nessas etapas não necessitam de análise, recebendo probabilidades fixas.</p>

              <v-autocomplete
                class="input-form"
                v-model="c.item.fields.stages"
                :items="getEtapas(c.item)"
                item-title="titulo"
                item-value="id"
                label="Escolha as etapas de conversão"
                multiple
                chips
                closable-chips
                density="comfortable"
              >
                <template v-slot:item="{ props, item }">
                  <v-list-item
                    v-bind="props"
                    :active="false"
                    :title="item.raw.titulo"
                  >
                    <template v-slot:prepend="{ isSelected }">
                      <v-checkbox-btn :model-value="isSelected"></v-checkbox-btn>
                    </template>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </div>

            <v-divider/>

            <div class="mt-4 container-data-form pa-4">
              <h4 class="mb-2 title-form">Público-alvo</h4>
              <p class="desc-form mb-6">Defina o público-alvo para o qual as predições serão geradas.</p>

              <v-autocomplete
                class="input-form"
                v-model="c.item.fields.level"
                :items="edulevels"
                item-title="titulo"
                item-value="id"
                label="Nível de ensino"
                multiple
                chips
                closable-chips
                density="comfortable"
                :menu-props="{ closeOnContentClick: false, closeOnBack: false }"
                :hide-no-data="true"
                :no-filter="false"
              >
                <template #prepend-item>
                  <v-list-item @click.stop :active="false">
                    <v-checkbox
                      label="Selecionar todos"
                      density="compact"
                      hide-details
                      :indeterminate="isSomeSelected(c.item, 'level', edulevels)"
                      :model-value="isAllSelected(c.item, 'level', edulevels)"
                      @mousedown.prevent
                      @click.stop
                      @update:model-value="(v) => onToggleAll(c.item, 'level', edulevels, v)"
                    />
                  </v-list-item>
                  <v-divider class="mt-1" />
                </template>

                <template #item="{ props, item: opt }">
                  <v-list-item v-bind="props" :active="false" :title="opt.raw.titulo" @click.stop>
                    <template #prepend>
                      <v-checkbox
                        density="compact"
                        hide-details
                        :model-value="(c.item.fields.level || []).map(String).includes(String(opt.raw.id))"
                        @mousedown.prevent
                        @click.stop
                        @update:model-value="(v) => onToggleSingle(c.item, 'level', edulevels, opt.raw.id, v)"
                      />
                    </template>
                  </v-list-item>
                </template>
              </v-autocomplete>

              <v-autocomplete
                class="input-form"
                v-model="c.item.fields.modality"
                :items="modalities"
                item-title="titulo"
                item-value="id"
                label="Modalidade"
                multiple
                chips
                closable-chips
                density="comfortable"
                :menu-props="{ closeOnContentClick: false, closeOnBack: false }"
                :hide-no-data="true"
                :no-filter="false"
              >
                <template #prepend-item>
                  <v-list-item @click.stop :active="false">
                    <v-checkbox
                      label="Selecionar todos"
                      density="compact"
                      hide-details
                      :indeterminate="isSomeSelected(c.item, 'modality', modalities)"
                      :model-value="isAllSelected(c.item, 'modality', modalities)"
                      @mousedown.prevent
                      @click.stop
                      @update:model-value="(v) => onToggleAll(c.item, 'modality', modalities, v)"
                    />
                  </v-list-item>
                  <v-divider class="mt-1" />
                </template>

                <template #item="{ props, item: opt }">
                  <v-list-item v-bind="props" :active="false" :title="opt.raw.titulo" @click.stop>
                    <template #prepend>
                      <v-checkbox
                        density="compact"
                        hide-details
                        :model-value="(c.item.fields.modality || []).map(String).includes(String(opt.raw.id))"
                        @mousedown.prevent
                        @click.stop
                        @update:model-value="(v) => onToggleSingle(c.item, 'modality', modalities, opt.raw.id, v)"
                      />
                    </template>
                  </v-list-item>
                </template>
              </v-autocomplete>

              <v-autocomplete
                class="input-form"
                v-model="c.item.fields.locations"
                :items="offers"
                item-title="titulo"
                item-value="id"
                label="Locais"
                multiple
                chips
                closable-chips
                density="comfortable"
                :menu-props="{ closeOnContentClick: false, closeOnBack: false }"
                :hide-no-data="true"
                :no-filter="false"
              >
                <template #prepend-item>
                  <v-list-item @click.stop :active="false">
                    <v-checkbox
                      label="Selecionar todos"
                      density="compact"
                      hide-details
                      :indeterminate="isSomeSelected(c.item, 'locations', offers)"
                      :model-value="isAllSelected(c.item, 'locations', offers)"
                      @mousedown.prevent
                      @click.stop
                      @update:model-value="(v) => onToggleAll(c.item, 'locations', offers, v)"
                    />
                  </v-list-item>
                  <v-divider class="mt-1" />
                </template>

                <template #item="{ props, item: opt }">
                  <v-list-item v-bind="props" :active="false" :title="opt.raw.titulo" @click.stop>
                    <template #prepend>
                      <v-checkbox
                        density="compact"
                        hide-details
                        :model-value="(c.item.fields.locations || []).map(String).includes(String(opt.raw.id))"
                        @mousedown.prevent
                        @click.stop
                        @update:model-value="(v) => onToggleSingle(c.item, 'locations', offers, opt.raw.id, v)"
                      />
                    </template>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </div>
            <v-divider/>
            <v-card-actions class="d-flex justify-end px-8 py-4">
              <v-btn
                class="px-6 py-5 d-flex"
                rounded="xl"
                variant="outlined"
                :style="{ color: '#505353', borderColor: '#C5C7C6' }"
                @click="onCancel"
                :disabled="isSubmitting"
              >
                Cancelar
              </v-btn>

              <v-btn
                variant="elevated"
                color="primary-60"
                class="px-6 py-5 d-flex elevation-0"
                rounded="xl"
                @click="onConfirmClose(c.item)"
                :disabled="isSubmitting || isFormInvalid || !hasChanges(c.item)"
              >
                Salvar
              </v-btn>
            </v-card-actions>
          </div>
        </v-expand-transition>
      </v-card>
    </div>
  </div>

  <RBPopUp
    v-model="disablePopUp"
    @confirm="confirmAction()"
    @cancel="cancelAction"
    confirm-text="Remover"
    cancel-text="Cancelar"
    confirm-color="error-40"
    cancel-color="neutral-35"
    variant-cancel="outlined"
  >
    <template #title>
      Remover Processo
    </template>
    <template #message>
      Você tem certeza que quer remover o processo? O processo será retirado na próxima atualização das probabilidades.
    </template>
  </RBPopUp>

  <RBPopUp
    v-model="disablePopUpDesativar"
    @confirm="confirmAction()"
    @cancel="cancelAction"
    :confirm-text="statusDialogConfig.confirmText"
    cancel-text="Cancelar"
    :confirm-color="statusDialogConfig.confirmColor"
    cancel-color="neutral-35"
    variant-cancel="outlined"
  >
    <template #title>
      {{ statusDialogConfig.title }}
    </template>
    <template #message>
      {{ statusDialogConfig.message }}
    </template>
  </RBPopUp>
</template>

<script>
import { Post, Patch } from "@/ai_studio/http/http.js";
import { formatDateForApi } from "@/ai_studio/utils/dataformatter";
import ChevronSteps from "@/ai_studio/components/common/ChevronSteps.vue";
import RBPopUp from "@/ai_studio/components/common/RBPopup.vue";
import { markRaw } from "vue";
import { VDateInput } from 'vuetify/labs/VDateInput'

export default {
  name: "ConfigurationCard",
  components: {
    ChevronSteps,
    RBPopUp,
    VDateInput
  },
  props: {
    items: { type: [Array, Object], required: true },
    offers: { type: Array, required: true },
    edulevels: { type: Array, required: true },
    modalities: { type: Array, required: true },
    processes: { type: [Array, Object], required: true }
  },
  data() {
    return {
      openCard: null,
      switch_: { status: false, label: "Desativado" },
      disablePopUp: false,
      disablePopUpDesativar: false,
      selectedProcess: null,
      statusAction: { intendedStatus: null },
      totalSteps: [],
      indicesSteps: [],
      localItems: [],
      originalMap: markRaw(new Map()),
      isSubmitting: false,
      menus: { level: false, modality: false, location: false },
    };
  },
  watch: {
    items: {
      immediate: true,
      handler(newItems) {
        const list = this.toArr(newItems);

        const prevMap = new Map(this.localItems.map(i => [i.pk, i]));
        this.localItems = list.map(it => this.normalizeItem(it, prevMap.get(it.pk)));

        this.originalMap = markRaw(new Map());
        for (const it of list) {
          const norm = this.normalizeItem(this._deepClone(it), null);
          const snap = this._extractComparable(norm);
          const frozen = this._deepFreeze(this._deepClone(snap));
          this.originalMap.set(String(it.pk), frozen);
        }
      }
    }
  },
  emits: ["confirm", "save"],

  computed: {
    cards() {
      return this.localItems.map((item, i) => ({
        item,
        index: i,
        cardId: item.pk ?? `pos-${i}`,
      }));
    },
    leftCards() {
      return this.cards.filter((_, i) => i % 2 === 0);
    },
    rightCards() {
      return this.cards.filter((_, i) => i % 2 === 1);
    },

    statusDialogConfig() {
      const intended = this.statusAction?.intendedStatus;
      const isBoolean = intended === true || intended === false;
      const activating = intended === true;

      return {
        title: isBoolean
          ? (activating ? "Ativar Processo" : "Desativar Processo")
          : "Atualizar status",
        message: isBoolean
          ? (activating
              ? "Você tem certeza que quer ativar o processo? Ele passará a valer na próxima atualização das probabilidades."
              : "Você tem certeza que quer desativar o processo? Ele será ignorado na próxima atualização das probabilidades.")
          : "Confirme a alteração de status do processo.",
        confirmText: isBoolean ? (activating ? "Ativar" : "Desativar") : "Confirmar",
        confirmColor: isBoolean ? (activating ? "primary-60" : "error-40") : "primary-60",
      };
    },

    isFormInvalid() {
      const opened = this.cards.find(c => c.cardId === this.openCard);
      return opened ? !opened.item.fields?.processes : false;
    },
  },

  methods: {
    toArr(v) {
      if (Array.isArray(v)) return v;
      if (v && typeof v === 'object' && Array.isArray(v.data)) return v.data;
      return [];
    },
    _deepClone(obj) {
      return obj == null ? obj : JSON.parse(JSON.stringify(obj));
    },
    _deepFreeze(obj) {
      if (!obj || typeof obj !== "object") return obj;
      Object.freeze(obj);
      for (const v of Object.values(obj)) {
        if (v && typeof v === "object" && !Object.isFrozen(v)) this._deepFreeze(v);
      }
      return obj;
    },
    _extractComparable(item) {
      const f = item.fields || {};
      f.steps = this.getFilledIndexes(item);
      return {
        pk: item.pk,
        process: String(f.processes ?? ""),
        dropout_steps: f.dropout_steps ?? null,
        conclusion_steps: f.conclusion_steps ?? null,
        steps: Array.isArray(f.stages) ? [...f.stages].map(v => String(v)) : [],
        education_level: Array.isArray(f.level) ? [...f.level].map(v => String(v)) : [],
        modality: Array.isArray(f.modality) ? [...f.modality].map(v => String(v)) : [],
        offers: Array.isArray(f.locations) ? [...f.locations].map(v => String(v)) : [],
        trained_model_id: f.trained_model_id ?? null,
        segmentation_name: f.segmentation_name ?? null,
        ref_date_registers: formatDateForApi(f.startDate || f.ref_date_registers) || null,
      };
    },
    _buildConfigsPayload(item) {
      const cmp = this._extractComparable(item);
      return {
        segmentation_name: cmp.segmentation_name ?? null,
        process: cmp.process,
        dropout_steps: cmp.dropout_steps,
        conclusion_steps: cmp.conclusion_steps,
        steps: cmp.steps,
        education_level: cmp.education_level,
        modality: cmp.modality,
        offers: cmp.offers,
        trained_model_id: cmp.trained_model_id ?? null,
        ref_date_registers: cmp.ref_date_registers
      };
    },
    _isDifferent(curr, orig) {
      const toStrSorted = (arr) => (Array.isArray(arr) ? [...arr].map(String).sort() : []);
      const eqArr = (a, b) => {
        const as = toStrSorted(a);
        const bs = toStrSorted(b);
        if (as.length !== bs.length) return false;
        return as.every((v, i) => v === bs[i]);
      };

      if (String(curr.process) !== String(orig.process)) return true;
      if ((curr.dropout_steps ?? null) !== (orig.dropout_steps ?? null)) return true;
      if ((curr.conclusion_steps ?? null) !== (orig.conclusion_steps ?? null)) return true;
      if (!eqArr(curr.steps, orig.steps)) return true;
      if (!eqArr(curr.education_level, orig.education_level)) return true;
      if (!eqArr(curr.modality, orig.modality)) return true;
      if (!eqArr(curr.offers, orig.offers)) return true;
      if ((curr.trained_model_id ?? null) !== (orig.trained_model_id ?? null)) return true;
      if ((curr.segmentation_name ?? null) !== (orig.segmentation_name ?? null)) return true;
      if ((curr.ref_date_registers ?? null) !== (orig.ref_date_registers ?? null)) return true;

      return false;
    },

    normalizeItem(item, prev) {
      const clone = JSON.parse(JSON.stringify(item));
      const f = (clone.fields ||= {});
      const toArr = (val) => {
        if (Array.isArray(val)) return val;
        if (val == null || val === "") return [];
        if (typeof val === "string") {
          try {
            const parsed = JSON.parse(val.replace(/'/g, '"'));
            return Array.isArray(parsed) ? parsed : (parsed != null ? [parsed] : []);
          } catch {
            return [val];
          }
        }
        return [val];
      };

      f.status = f.status === true || f.status === 1 || f.status === "1";
      f.education_level = toArr(f.education_level);
      f.modality = toArr(f.modality);
      f.offer = toArr(f.offer);
      f.startDate = f.ref_date_registers
        ? String(f.ref_date_registers).split("T")[0]
        : (f.startDate || "");

      f.level = toArr(f.level?.length ? f.level : f.education_level);
      f.locations = toArr(f.locations?.length ? f.locations : f.offer);

      const etapasIds = new Set(this.getEtapas(clone).map(e => String(e.id)));

      let stagesCandidate = toArr(f.stages?.length ? f.stages : f.steps);

      f.stages = stagesCandidate
        .map(v => String(v))
        .filter(id => etapasIds.has(id));

      if (prev && prev.fields) {
        const pf = prev.fields;
        f.status    = pf.status ?? f.status;
        f.stages    = (pf.stages && pf.stages.length) ? pf.stages : f.stages;
        f.level     = (pf.level && pf.level.length) ? pf.level : f.level;
        f.modality  = (pf.modality && pf.modality.length) ? pf.modality : f.modality;
        f.locations = (pf.locations && pf.locations.length) ? pf.locations : f.locations;
        f.startDate = pf.startDate || f.startDate;
      }

      return clone;
    },

    toggleDropdown(cardId) {
      this.openCard = this.openCard === cardId ? null : cardId;
    },

    async toggleSwitchStatus(item) {
      const intended = item.fields.status;
      item.fields.status = !intended;
      item.fields.label = item.fields.status ? "Ativado" : "Desativado";

      this.selectedProcess = item;
      this.statusAction.intendedStatus = intended;
      this.disablePopUpDesativar = true;
    },

    openDisablePopup(item) {
      this.selectedProcess = item;
      this.disablePopUp = true;
    },

    async confirmAction() {
      try {
        if (this.disablePopUpDesativar && this.selectedProcess) {
          const item = this.selectedProcess;
          const newStatus = this.statusAction.intendedStatus ? 1 : 0;

          await Post(JSON.stringify({ pk: item.pk, status: newStatus }), "insights/switchConfigStatus");

          item.fields.status = !!this.statusAction.intendedStatus;
          item.fields.label = item.fields.status ? "Ativado" : "Desativado";

          this.statusAction.intendedStatus = null;
          this.disablePopUpDesativar = false;
          this.selectedProcess = null;
          return;
        }
        if (this.disablePopUp && this.selectedProcess) {
          const ok = await Patch(`insights/deleteConfigProcess/${this.selectedProcess.pk}/`);
          if (ok) this.$emit("confirm");
          this.disablePopUp = false;
          this.selectedProcess = null;
          return;
        }
      } catch (err) {
        console.error("Erro ao confirmar ação:", err);
      } finally {
        this.disablePopUpDesativar = false;
        this.disablePopUp = false;
      }
    },

    cancelAction() {
      this.disablePopUpDesativar = false;
      this.disablePopUp = false;
      this.statusAction.intendedStatus = null;
      this.selectedProcess = null;
    },

    getProcessById(procId) {
      const pid = String(procId);
      const list = this.toArr(this.processes);
      const found = list.find(p => String(p.id) === pid);
      if (found) return found;
      return this.processes?.[pid] ?? this.processes?.[Number(pid)] ?? null;
    },

    getEtapas(item) {
      const proc = this.getProcessById(item.fields.processes);
      return proc?.etapas ?? [];
    },

    getTotalSteps(item) {
      return this.getEtapas(item).length;
    },

    getFilledIndexes(item) {
      const etapas = this.getEtapas(item);
      const stages = Array.isArray(item.fields.stages) ? item.fields.stages : [];
      return stages
        .map(stageId => etapas.findIndex(etapa => String(etapa.id) === String(stageId)))
        .filter(index => index >= 0);
    },

    getChanges() {
      const updates = [];
      for (const item of this.localItems) {
        const curr = this._extractComparable(item);
        const orig = this.originalMap.get(String(item.pk));
        if (!orig) continue;
        if (this._isDifferent(curr, orig)) {
          updates.push({
            pk: item.pk,
            configs: this._buildConfigsPayload(item)
          });
        }
      }
      return updates;
    },

    async onConfirmClose(item) {
      try {
        this.isSubmitting = true;

        const curr = this._extractComparable(item);
        const orig = this.originalMap.get(String(item.pk));

        if (!orig || this._isDifferent(curr, orig)) {
          const configs = this._buildConfigsPayload(item);
          this.$emit('save', { pk: item.pk, configs });
        }
        this.openCard = null;
      } catch (e) {
        console.error('Falha ao preparar payload para salvar:', e);
      } finally {
        this.isSubmitting = false;
      }
    },

    isAllSelected(card, field, itemsArr) {
      const allIds = (itemsArr || []).map(o => String(o.id));
      const sel = (card.fields?.[field] || []).map(String);
      return allIds.length > 0 && sel.length === allIds.length && allIds.every(id => sel.includes(id));
    },

    isSomeSelected(card, field, itemsArr) {
      const total = (itemsArr || []).length;
      const selLen = (card.fields?.[field] || []).length;
      return selLen > 0 && selLen < total;
    },

    toggleSelectAll(card, field, itemsArr, value) {
      if (!card.fields) card.fields = {};
      card.fields[field] = value ? (itemsArr || []).map(o => o.id) : [];
    },

    toggleSingle(card, field, itemsArr, id, checked) {
      if (!card.fields) card.fields = {};
      const set = new Set((card.fields[field] || []).map(String));

      if (checked) set.add(String(id));
      else set.delete(String(id));

      const byId = new Map((itemsArr || []).map(o => [String(o.id), o.id]));
      card.fields[field] = Array.from(set).map(s => byId.get(s) ?? s);
    },

    onToggleAll(row, field, options, checked) {
      this.toggleSelectAll(row, field, options, checked);
    },

    onToggleSingle(row, field, options, id, checked) {
      this.toggleSingle(row, field, options, id, checked);
    },

    hasChanges(item) {
      const curr = this._extractComparable(item);
      const orig = this.originalMap.get(String(item.pk));
      if (!orig) return true;
      return this._isDifferent(curr, orig);
    },
  }
};
</script>

<style>
.container-configurations {
  display: flex;
  gap: 24px;
  align-items: flex-start;
  width: 100%;
}

.config-col {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 300px;
}

.container-card {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-radius: 8px;
  border: 1px solid #DCE0E0;
  background: #FFF;
  overflow: hidden;
}

@media (max-width: 900px) {
  .container-configurations {
    flex-direction: column;
  }
  .config-col {
    min-width: 0;
  }
}

.container-header {
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
}

.container-title-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}

.title-form {
  color: #3C4043;
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.desc-form {
  color: #5F6368;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  align-self: stretch;
  text-align: start;
}

.input-form {
  align-self: stretch;
}

.container-data-form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
}

.container-data-form .v-input {
  margin-top: -8px;
}

.steps-wrap {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
}
</style>
